import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson13 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        <?php
        $numbers = array(1,2,3,4,5);
        ?>

        `
      );
      const code1 = (
        'text',
        `
        <?php
        echo $number[0];  // Outputs 1
        ?>

        `
      );
      const code2 = (
        'text',
        `
        <?php
        echo count($numbers);  // Outputs 5
        ?>

        `
      );


      const code3 = (
        'text',
        `
        // Adding elements to an array
        array_push($colors, 'yellow');

        // Removing elements from an array
        array_pop($colors);

        // Merging arrays
        $mergedArray = array_merge($colors, ['orange', 'purple']);
        `
      );
      const code4 = (
        'text',
        `
        // Using foreach loop to iterate through an array
        foreach ($person as $key => $value) {
            echo "Key: $key, Value: $value <br>";
        }
        `
      );

      const code5 = (
        'text',
        `
        // Searching for a value in an array
        $position = array_search('green', $colors);

        // Checking if a key exists in an array
        if (array_key_exists('name', $person)) {
            echo "Key 'name' exists in the array.";
        }

        // Checking if a value exists in an array
        if (in_array('blue', $colors)) {
            echo "The value 'blue' exists in the array.";
        }

        // Slicing an array
        $subset = array_slice($colors, 1, 2); // Returns ['green', 'blue']

        `
      );




  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>Arrays in PHP</strong></h3>
    <p>In PHP, an array is a data type that allows you to store a collection of values in a single variable. Arrays are typically used to store lists of items, such as strings, numbers, or objects.</p>
    <p>Here's an example of how to create an array in PHP:</p>
    <CopyBlock
    language={"php"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />

    <p>This creates an array called <b>`$numbers`</b> that contains the values 1, 2, 3, 4, and 5. You can access the values in an array using an index, which is a number that corresponds to the position of the value
       in the array. For example, to access the first value in the array (which is 1), you would use the index 0:</p>

    <CopyBlock
    language={"php"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>You can also use the <b>count()</b> function to get the number of values in an array:</p>
    <CopyBlock
    language={"php"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <br />
    <p>PHP also provides several functions for manipulating arrays, such as <b>sort()</b> for sorting the values in an array, <b>array_merge()</b> for merging two or more arrays together, and <b>array_slice()</b> for extracting a portion of an array.</p>
    </div>

  <div className="alert alert-secondary" role="alert">
  <h3><strong>Functions</strong></h3>
  <p>PHP provides numerous built-in functions for working with arrays. These functions allow you to add elements, remove elements, merge arrays, and perform other operations.</p>

  <CopyBlock
  language={"php"}
  text={code3}
  showLineNumbers={lineNumbers}
  theme={dracula}
  wrapLines={true}
  codeBlock
  />

</div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Iterating</strong></h3>
<p> You can iterate through arrays using loops such as foreach, for, or while to access and manipulate each element.</p>

<CopyBlock
language={"php"}
text={code4}
showLineNumbers={lineNumbers}
theme={dracula}
wrapLines={true}
codeBlock
/>
</div>

<div className="alert alert-secondary" role="alert">
<h3><strong>Array Operations</strong></h3>
<p>PHP supports various operations on arrays, including searching for values, checking for the existence of keys or values, and slicing arrays to extract subsets of data.</p>

<CopyBlock
language={"php"}
text={code5}
showLineNumbers={lineNumbers}
theme={dracula}
wrapLines={true}
codeBlock
/>
</div>

</div>
</div>
</div>
</HTMLCourseNavProvider>
  )
}
export default PhpLesson13
